import type { IModuleDefinition } from '@platform/core/types';
import type { ITypeRow } from './ITypeRow';

/**
 * Рядки «Встановлених модулів» і «Форм» (прототип v4: wsA.modules — кожен реалізований тип запису): у порядку модулів, у модулі — головний
 * тип, далі реалізовані дочірні; спроєктовані таблиці належать своєму батьківському типу, без батька (довідники) — головному; приховані типи (hidden) не показуються. Чиста функція.
 */
export function typeRows(definitions: readonly IModuleDefinition[]): ITypeRow[] {
  return definitions.flatMap((def) => {
    const main = def.recordTypes.find((r) => r.main) ?? def.recordTypes[0];
    const built = def.recordTypes.filter((r) => r.status !== 'designed' && !r.hidden).sort((a, b) => Number(b === main) - Number(a === main));
    const designed = def.recordTypes.filter((r) => r.status === 'designed' && !r.hidden);
    return built.map((rt) => ({ def, rt, designed: designed.filter((d) => (d.parent ? d.parent === rt.key : rt === main)) }));
  });
}
